export default __webpack_public_path__ + "static/media/herdlink.7ca864d6.jpg";